// State helpers for the dashboard widget data provider.
import DashboardHeaderHandler from "../handlers/DashboardHeaderHandler";
import DashboardMetadataHandler from "../handlers/DashboardMetadataHandler";

/**
 * Create default dashboard visibility state.
 */
export function createDefaultDashboardVisibilityState() {
    return {
        published: true,
        publishedStart: null,
        publishedEnd: null,
    };
}

/**
 * Reset dashboard runtime editor state.
 *
 * @param {*} provider
 */
export function resetDashboardRuntimeEditorState(provider) {
    provider.visibility = createDefaultDashboardVisibilityState();
    provider.metadataHandler = new DashboardMetadataHandler([]);
    provider.headerHandler = new DashboardHeaderHandler([]);
}

/**
 * Apply dashboard editor state from response.
 *
 * @param {*} provider
 * @param {*} dashboard
 */
export function applyDashboardEditorStateFromResponse(provider, dashboard) {
    const normalizedDashboard = provider.getDashboardFromResponse(dashboard);
    const widgets = Array.isArray(normalizedDashboard.widgets) ? normalizedDashboard.widgets : [];

    provider.id = normalizedDashboard.id || provider.id;
    provider.title = normalizedDashboard.title || provider.translate('Dashboard');
    provider.dashboardTabs = provider.normalizeDashboardTabs(normalizedDashboard.tabs);
    provider.blocks = provider.normalizeWidgets(widgets);
    provider.breakpoints = provider.normalizeBreakpoints(normalizedDashboard.breakpoints, widgets);
    resetDashboardRuntimeEditorState(provider);
}
